import riot from 'riot';
import events from '../src/events.js';
import { putUser as libPutUser, getActivities as libGetActivities, postActivities as libPostActivities, putActivities as libPutActivities } from '../src/lib.js';
riot.tag2('activities', '<div class="column is-12" style="margin-top: -75px;"> <div class="columns is-multiline" if="{!user}"> <div class="column is-12"> <article class="message is-warning is-light is-medium"> <div class="message-header"> <p>Please login to see your lessons!</p> </div> <div class="message-body"> Once you login you will be able to create or join lessons and have tons of fun learning! </div> </article> </div> </div> <nav class="navbar" role="navigation" aria-label="main navigation" if="{user && !loading_activities && !selectedActivity}" style="background-color: rgb(245,245,245);"> <div id="lessonNav" class="navbar-menu is-active"> <div class="navbar-start"> <div class="navbar-item"> <div class="field has-addons has-addons-centered"> <div class="control"> <a class="button is-success" onclick="{joinLessonClick}"> <span class="icon is-small"> <i class="fas fa-plus"></i> </span> <span>Join Lesson</span> </a> </div> <div class="control"> <input class="input" type="text" id="joinLessonRefInput" placeholder="Enter Lesson Reference"> </div> </div> </div> <div class="navbar-item" if="{putUserError}"> <div class="notification is-danger"> <button class="delete" onclick="{clearPutUserError}"></button> {putUserError} </div> </div> </div> <div class="navbar-end"> <div class="navbar-item"> <div class="buttons"> <button class="button is-info" onclick="{toggleActivityViewFilter}"> <span class="icon is-small"> <i class="{viewCompletedActivities ? \'fas fa-list\' : \'fas fa-chart-line\'}"></i> </span> <span if="{!viewCompletedActivities}">My Dashboard</span> <span if="{viewCompletedActivities}">View Activities</span> </button> <button class="button is-warning" onclick="{refreshClick}"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> </button> </div> </div> </div> </div> </nav> <div class="container is-fluid has-text-centered" show="{loading_activities}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <div class="columns is-multiline" if="{user && !loading_activities && !selectedActivity && !error && !viewCompletedActivities && activities.length==0}"> <div class="column is-12"> <article class="message is-info is-light is-medium"> <div class="message-header"> <p>Let\'s get you started!</p> </div> <div class="message-body"> Use the Join Lesson box to enter the lesson code to join and existing lesson, or hop over to the lessons or projects tab to get started! </div> </article> </div> </div> <div class="columns is-multiline" style="margin-top: 5px;" if="{user && !loading_activities && !selectedActivity && !error && !viewCompletedActivities}"> <virtual each="{a in activities}" if="{!error && a.active}"> <div class="column is-4" if="{!a.lesson}"> <div class="card" id="activity_{a.activity_ref}" style="display:flex; flex-direction:column; height:100%;"> <div class="card-content"> <article class="message is-warning"> <div class="message-header"> <p>Lesson Unavailable</p> </div> <div class="message-body"> The lesson for this activity (code <strong>{a.activity_ref}</strong>) could not be loaded. <p class="is-size-7 mt-2" if="{a.lesson_error}">{a.lesson_error}</p> <div class="buttons mt-3"> <button class="button is-danger is-small" if="{a.user_id==user.user_id}" onclick="{endActivityClick}">End Activity</button> </div> </div> </article> </div> </div> </div> <div class="column is-4" if="{a.lesson}"> <div class="card {highlightActivityRef === a.activity_ref ? \'has-background-warning-light\' : \'\'}" id="activity_{a.activity_ref}" style="display:flex; flex-direction:column; height:100%;"> <div class="card-content"> <div class="media"> <div class="media-left"> <figure class="image is-48x48"> <img riot-src="img/{a.lesson.icon}" alt="{a.lesson.name} Icon" onerror="this.onerror=null; this.src=\'img/brand/Edjro_Logo_Mark_Navy.png\';"> </figure> </div> <div class="media-content"> <p class="title is-4" onclick="{selectActivityDetails}">{a.lesson.name}</p> <p class="subtitle is-6"> Activity Code: {a.activity_ref} <span class="tag is-warning is-small ml-2" if="{highlightActivityRef === a.activity_ref}"> <span class="icon is-small"> <i class="fas fa-arrow-right"></i> </span> <span>Resume Here</span> </span> </p> </div> <div class="media-right"> <button class="button" onclick="{toggleQRCode}"> <span class="icon is-small"> <i class="fa fa-qrcode"></i> </span> </button> </div> </div> <div class="content"> <div class="field is-grouped is-grouped-multiline" show="{qrCodes[a.activity_ref] && !qrCodes[a.activity_ref].show}"> <div class="control"> <div class="tags has-addons "> <span class="tag is-dark ">Grade Level</span> <span class="tag is-primary ">{a.lesson.grade_level?a.lesson.grade_level:\'All\'}</span> </div> </div> <div class="control"> <div class="tags has-addons "> <span class="tag is-dark ">Activity Type</span> <span class="tag is-primary ">{a.lesson.type}</span> </div> </div> </div> <div class="notification" show="{qrCodes[a.activity_ref] && !qrCodes[a.activity_ref].show}"> <div class="field"> <label class="label">Select Kit</label> <div class="control"> <div class="select"> <select id="selectDeviceToggle_{a.activity_ref}"> <option each="{d in a.devices}" riot-value="{d.id}">{d.name}</option> </select> </div> </div> </div> </div> <article class="message" show="{qrCodes[a.activity_ref] && qrCodes[a.activity_ref].show}"> <div class="message-header"> <p>Scan Code to Join!</p> </div> <div class="message-body" id="activityQRCode_{a.activity_ref}"></div> </article> <div class="buttons"> <button id="viewDetails" class="button is-success" if="{a.lesson.steps[0].type !=\'gslides\'}" onclick="{selectActivityDetails}"> Resume {a.lesson.type?a.lesson.type:\'Lesson\'} ({a.lesson.steps.length} Steps) </button> <button class="button is-success" if="{a.lesson.steps[0].type==\'gslides\'}" onclick="{selectActivityDetails}"> Resume {a.lesson.type?a.lesson.type:\'Lesson\'} (Google Slides) </button> <button id="viewDash" class="button is-warning" if="{a.user_id==user.user_id}" onclick="{selectActivityDashboard}"> Dashboard </button> <button class="button is-danger" if="{a.user_id==user.user_id}" onclick="{endActivityClick}"> End {a.lesson.type?a.lesson.type:\'Lesson\'} </button> </div> </div> </div> </div> </div> </virtual> </div> <user-dashboard if="{!loading_activities && !selectedActivity && !error && viewCompletedActivities}" activities="{activities}"></user-dashboard> <div class="columns is-multiline" if="{error}"> <div class="column is-12"> <article class="message is-danger"> <div class="message-header"> <p>Oh No!</p> <button class="delete" aria-label="delete"></button> </div> <div class="message-body"> It looks like there was an error loading your lessons! Try to refresh the page and if the problem persists, please check out status page to see if there are any ongoing issues. Thank you for you patience! <button class="button is-warning" onclick="{refreshClick}"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> <span>Refresh Lessons</span> </button> </div> </article> </div> </div> <activity-dashboard device="{selectedDeviceId}" if="{user && selectedActivity && viewPage==⁗dashboard⁗}"></activity-dashboard> <activity-details deviceid="{selectedDeviceId}" if="{user && selectedActivity && viewPage==⁗details⁗}"></activity-details>', '', '', function(opts) {

            var self = this;
            self.error = undefined;
            self.putUserErrror = undefined;
            self.loading_activities = true;
            self.selectedActivity = undefined;
            self.selectedDeviceId = undefined;
            self.viewPage = "details";
            self.auto_reload = undefined;
            self.viewCompletedActivities = false;
            self.highlightActivityRef = undefined;
            self.activities = [];

            self.qrCodes = {};

            self.on('mount', function() {
                getUser();
                if (self.user) {
                    getActivities();
                } else {

                    self.loading_activities = false;
                }
            });

            events.on('auth_complete', function() {
                self.user = 1;
                self.loading_activities = true;
                self.update();
            });

            events.on('users_loaded', function(user) {

                getUser();
                if (self.user && user && Object.keys(user).length > 0) {

                    getActivities();
                }
            });

            events.on('auth_logout', function(data) {

                self.user = undefined;
                self.activities = [];
                self.selectedActivity = undefined;
                self.loading_activities = false;
                self.error = "Please log in to continue";
                self.update();
            });

            events.on('activities_loaded', function(activities) {

                events.emit('dashboard_data', activities);

                setTimeout(function() {
                    activities.forEach(function(a) {
                        ensureQRCodeForActivity(a);
                    });
                    self.update();
                }, 0);

                self.update();
            });

            events.on('new_activity_created', function() {
                getActivities();
            });

            events.on('progress_updated', function(data) {
                self.loading_activities = false;

                getUser();
            });

            events.on('duplicate_activity', function(activity) {
                self.startDuplicateActivityClick({ item: { a: activity } });
            });

            events.on('navigate_to_activity', function(payload) {
                const { act_ref, view, params } = payload || {};
                var q = params || (typeof route !== 'undefined' && route.query ? route.query() : {});
                if (act_ref === "join") {
                    self.joinLesson(q.activity_ref);
                    routerHelpers.navigate('activities');
                } else if (act_ref && self.activities) {

                    self.viewCompletedActivities = false;

                    getLoadedActivityByRef(act_ref);
                    if ((q.view || view) == "dashboard") {
                        self.viewPage = "dashboard";

                        routerHelpers.navigate('activities', act_ref, 'dashboard');
                        self.selectActivity(q.user_id);
                    } else {

                        console.log("set selected device id to " + q.device)

                        if (self.selectedActivity && self.selectedActivity.device_ids && self.selectedActivity.device_ids.includes(q.device)) {
                            console.log("navigated to valid details page with valid device " + q.device)
                            self.selectedDeviceId = q.device;
                            self.viewPage = "details";

                            if (q.step || (params && params.step)) {
                                self.targetStep = parseInt(q.step || params.step);
                                console.log("Target step set to:", self.targetStep);
                            }

                            self.selectActivity(undefined);
                        } else {

                            self.unselectActivity();
                        }
                    }
                } else if (self.activities) {
                    self.unselectActivity();
                } else {

                    console.log("waiting for activities to load before navigating to activity")
                }
            });

            events.on('navigate_to_activity_step', function(payload) {
                const { act_ref, stepNumber, params } = payload || {};
                if (act_ref && self.activities) {
                    getLoadedActivityByRef(act_ref);
                    if (self.selectedActivity) {

                        self.viewPage = "details";
                        if (params && params.device) {
                            self.selectedDeviceId = params.device;
                        }
                        self.targetStep = stepNumber;
                        console.log("Direct step navigation to step:", stepNumber);
                        self.selectActivity(undefined);
                    }
                } else if (!self.activities) {

                    console.log("waiting for activities to load before navigating to step")
                }
            });

            events.on('navigate_to_activities_list', function(params) {
                self.selectedActivity = undefined;
                self.viewPage = "list";

                if (params && params.highlight) {
                    self.highlightActivityRef = params.highlight;

                    setTimeout(function() {
                        self.scrollToHighlightedActivity();
                    }, 100);
                } else {
                    self.highlightActivityRef = undefined;
                }

                self.update();

                setTimeout(function() {
                    if (self.activities && self.activities.length > 0) {
                        self.activities.forEach(function(a) {
                            ensureQRCodeForActivity(a, true);
                        });
                    }
                    self.update();
                }, 0);
            });

            this.scrollToHighlightedActivity = function() {
                if (self.highlightActivityRef) {
                    var element = document.getElementById('activity_' + self.highlightActivityRef);
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });

                        element.style.boxShadow = '0 0 20px rgba(255, 193, 7, 0.8)';
                        setTimeout(function() {
                            element.style.boxShadow = '';
                        }, 3000);
                    }
                }
            }.bind(this)

            this.toggleActivityViewFilter = function(e) {
                self.viewCompletedActivities = !self.viewCompletedActivities;
                console.log('Toggled viewCompletedActivities to:', self.viewCompletedActivities);
                console.log('Activities data:', self.activities);
                self.update();
            }.bind(this)

            this.toggleQRCode = function(e) {
                activityRef = e.item.a.activity_ref;
                ensureQRCodeForActivity(e.item.a);

                if (self.qrCodes[activityRef]) {
                    self.qrCodes[activityRef].show = !self.qrCodes[activityRef].show;
                    self.update();
                }
            }.bind(this)

            function ensureQRCodeForActivity(activity, forceRebuild) {
                if (!activity || !activity.active || !activity.activity_ref) {
                    return false;
                }

                var activityRef = activity.activity_ref;
                var elementId = "activityQRCode_" + activityRef;
                var element = document.getElementById(elementId);

                if (!element) {
                    return false;
                }

                var hasRenderedQr = element.children && element.children.length > 0;

                if (!forceRebuild && self.qrCodes[activityRef] && self.qrCodes[activityRef].qrcode && hasRenderedQr) {
                    return true;
                }

                element.innerHTML = '';

                var activityQRCode = new QRCode(element, {
                    text: window.location.origin + '/#activities/join?activity_ref=' + activityRef,
                    width: 128,
                    height: 128,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H
                });

                self.qrCodes[activityRef] = {
                    show: false,
                    qrcode: activityQRCode
                };

                return true;
            }

            this.joinLessonClick = function(e) {
                ref = document.getElementById("joinLessonRefInput").value;
                self.joinLesson(ref);
            }.bind(this)

            this.joinLesson = function(ref) {

                if (self.activities) {
                    for (var i = 0; i < self.activities.length; i++) {
                        if (ref == self.activities[i].activity_ref) {

                            console.log("User has already joined this activity! Please click below!")
                            return
                        }
                    }
                }

                progress_data = {
                    "activity_ref": ref,
                    "step": 0,
                    "device": undefined
                }
                self.loading_activities = true;
                putUser({
                    'activities': [ref],
                    'progress': progress_data
                });

                self.update();
            }.bind(this)

            this.clearPutUserError = function(e) {
                self.putUserError = undefined;
                self.update();
            }.bind(this)

            this.refreshClick = function(e) {
                self.error = undefined;
                if (self.user) {
                    getActivities();
                }
            }.bind(this)

            this.unselectActivity = function() {
                self.selectedActivity = undefined;
                self.targetStep = undefined;
                clearInterval(self.auto_reload);
                self.auto_reload = undefined;
                routerHelpers.navigate('activities');
                self.update();
            }.bind(this)

            this.selectActivityDashboard = function(e) {
                self.selectedActivity = e.item.a;
                if (self.user && self.selectedActivity.user_id == self.user.user_id) {
                    routerHelpers.navigate('activities', self.selectedActivity.activity_ref, 'dashboard');
                } else {

                    return
                }
            }.bind(this)

            this.selectActivityDetails = function(e) {

                self.highlightActivityRef = undefined;

                self.selectedActivity = e.item.a;
                console.log("Selecting activity:", self.selectedActivity.activity_ref);
                console.log("Activity devices:", JSON.stringify(self.selectedActivity.devices));
                console.log("Activity device_ids:", JSON.stringify(self.selectedActivity.device_ids));

                var devices = self.selectedActivity.devices || [];
                if (devices.length === 0) {
                    console.error("No devices for activity:", self.selectedActivity.activity_ref);
                    return;
                }

                var devSel = document.getElementById("selectDeviceToggle_" + self.selectedActivity.activity_ref);
                var selectedIndex = (devSel && devSel.selectedIndex >= 0 && devSel.options.length > 0) ? devSel.selectedIndex : 0;
                var selectedDevice = devices[selectedIndex] || devices[0];

                self.selectedDeviceId = selectedDevice.id;
                console.log("Setting selectedDeviceId to:", self.selectedDeviceId);

                if (!self.selectedDeviceId) {
                    console.error("Device ID is undefined after selection");
                    return;
                }

                self.viewPage = "details";

                if (self.user && self.user.progress) {
                    const userProgress = self.user.progress.find(p => p.activity_ref === self.selectedActivity.activity_ref);
                    if (userProgress && userProgress.step > 0) {
                        self.targetStep = userProgress.step;
                    }
                }

                const params = { device: self.selectedDeviceId };
                if (self.targetStep) params.step = self.targetStep;
                routerHelpers.syncURL('activities', self.selectedActivity.activity_ref, 'details', params);

                self.selectActivity(undefined);
            }.bind(this)

            function updateUserProgress() {

                if (self.viewPage == "dashboard") {
                    return {}
                }

                updatedProgress = false;

                progress_data = {
                    "activity_ref": self.selectedActivity.activity_ref,
                    "step": 0,
                    "device": self.selectedDeviceId
                }

                if (self.user.progress) {
                    for (var p = 0; p < self.user.progress.length; p++) {
                        if (self.user.progress[p].activity_ref == self.selectedActivity.activity_ref) {

                            if (self.selectedDeviceId != self.user.progress[p].device) {

                                progress_data = {
                                    "activity_ref": self.selectedActivity.activity_ref,
                                    "step": self.user.progress[p].step,
                                    "device": self.selectedDeviceId
                                }

                                updatedProgress = true;
                            } else {

                                progress_data = self.user.progress[p];
                            }

                            break;
                        }
                    }
                }

                if (!self.user.progress || !self.user.progress.find(p => p.activity_ref == self.selectedActivity.activity_ref)) {
                    updatedProgress = true;
                }

                if (updatedProgress) {
                    putUser({
                        'progress': progress_data
                    });
                }
                return progress_data
            }

            this.selectActivity = function(participant_id) {

                progress_data = updateUserProgress();

                self.update();
                if (self.viewPage == "details") {
                    const evt = {
                        selectedActivity: self.selectedActivity,
                        selectedDeviceId: self.selectedDeviceId,
                        targetStep: self.targetStep,
                        progress_data,
                    };
                    events.emit("select_activity_details", evt);
                } else if (self.viewPage == "dashboard") {
                    const evt = {
                        selectedActivity: self.selectedActivity,
                        progress_data,
                        participant_id,
                    };
                    events.emit("select_activity_dash", evt);
                }
            }.bind(this)

            this.startDuplicateActivityClick = function(e) {
                var data = {}
                data.lesson = e.item.a.lesson_id;
                data.device_ids = e.item.a.device_ids;
                postActivities(data);
            }.bind(this)

            this.endActivityClick = function(e) {
                var data = {}
                data.activity_ref = e.item.a.activity_ref;
                putActivities(data);
            }.bind(this)

            function getUser() {
                user_profile = localStorage.getItem('profile');
                if (user_profile && user_profile != "undefined") {
                    self.update({
                        user: JSON.parse(user_profile)
                    });
                }
            };

            function getLoadedActivityByRef(activity_ref) {
                self.selectedActivity = undefined;
                for (var i = 0; i < self.activities.length; i++) {
                    if (self.activities[i].activity_ref == activity_ref) {
                        self.selectedActivity = self.activities[i];
                        break;
                    }
                }
            }

            function getActivities() {
                self.loading_activities = true;
                libGetActivities().then(function(res) {
                    self.loading_activities = false;

                    if (!window.appData) {
                        window.appData = {};
                    }

                    window.appData.activities = res['data']['activities'];
                    window.appData.activitiesLoaded = true;

                    self.update({
                        activities: res['data']['activities'],
                        error: undefined
                    });

                    events.emit('activities_loaded',
                        res['data']['activities']
                    );
                }).catch(function(error) {
                    console.error('Activities Error:' + error);
                    self.loading_activities = false;
                    self.update({
                        activities: [],
                        error: error
                    });
                });

            }

            function postActivities(data) {

                self.loading_activities = true;
                libPostActivities(data).then(function(res) {
                    self.loading_activities = false;
                    getActivities();
                }).catch(function(error) {
                    console.error('POST Activities Error:' + error);
                    self.loading_activities = false;
                    self.update({
                        activities: [],
                        error: error
                    });
                });

            }

            function putActivities(data) {

                self.loading_activities = true;
                libPutActivities(data).then(function(res) {
                    self.loading_activities = false;

                    if (self.user && self.user.progress) {
                        self.user.progress = self.user.progress.filter(
                            p => p.activity_ref !== data.activity_ref
                        );
                        localStorage.setItem('profile', JSON.stringify(self.user));
                    }

                    events.emit('activity_ended', {
                        "activity_ref": data.activity_ref
                    })
                    getActivities();
                }).catch(function(error) {
                    console.error('PUT Activities Error:' + error);
                    self.loading_activities = false;
                    self.update({
                        activities: [],
                        error: error
                    });
                });

            }

            function putUser(data) {
                libPutUser(data).then(function(user) {
                    putUserError = undefined;
                    if (user) {

                        localStorage.setItem('profile', JSON.stringify(user));

                        if (data['activities']) {

                            events.emit('users_loaded', user)
                        } else {

                            events.emit("progress_updated", user)
                        }
                    }
                }).catch(function(error) {
                    self.loading_activities = false;
                    self.update({
                        putUserError: error
                    });
                });

            }
});
